module.exports = __webpack_public_path__ + "static/img/get_un_purse.5bd29061.png";